import $ from "jquery";

class CartNavigation {
    constructor() {
        this.open();
        this.close();
    }

    open() {
        let _this = this;
        const burger_btn = $('.cart-menu');

        burger_btn.on('click', function (e) {
            e.preventDefault();

            let side_menu = $('#side-cart');
            side_menu.removeAttr('style');

            _this.toggleMenu('open')
        })
    }

    close() {
        let _this = this;
        const close_btn = $('#side-cart .menu-close');

        close_btn.on('click', function (e) {
            e.preventDefault();
            _this.toggleMenu('close')
        })
    }

    toggleMenu(option = '') {
        const menu = document.querySelector('#side-cart');
        menu.classList.toggle('open');
        this.toggleBackdrop(option);
    }


    toggleBackdrop(option) {
        if (option === 'open') {
            $(document).find('body').append('<div class="block-backdrop"></div>');
            setTimeout(function () {
                $(document).find('.block-backdrop').addClass('open');
            }, 100)
        } else {
            $(document).find('.block-backdrop').removeClass('open');
            setTimeout(function () {
                $(document).find('.block-backdrop').remove();
            }, 600)
        }
    }
}

export default CartNavigation